import styled from 'styled-components';
import loginRtBG from '../../../assets/login_rt_bg.png';

export const MainContainer = styled.div`
  height: 100vh;
  background: url(${loginRtBG}) no-repeat left top;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
`;

export const InnerContainer = styled.div`
  height: 100vh;
  background: linear-gradient(360deg, #0d3b79 0%, rgba(13, 59, 121, 0) 100%);
`;

export const BodyContainer = styled.div`
  padding: 205px 40px 0 50px;
`;

export const Header = styled.div`
  font-size: 60px;
  line-height: 89px;
  color: #ffffff;

  p {
    margin: 0;
    padding: 0;
    color: #8fffff;
    letter-spacing: 4px;
  }
`;

export const Description = styled.div`
  color: #ffffff;
  margin-top: 50px;
  font-size: 14px;
  line-height: 22px;
`;
export const CopyRights = styled.div`
  margin-top: 30px;
  color: #ffffff;
  font-size: 10px;
`;
